import { render, staticRenderFns } from "./dynamic_table.vue?vue&type=template&id=5da1ad42&scoped=true&"
import script from "./dynamic_table.vue?vue&type=script&lang=ts&"
export * from "./dynamic_table.vue?vue&type=script&lang=ts&"
import style0 from "./dynamic_table.vue?vue&type=style&index=0&id=5da1ad42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da1ad42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VChip,VDataTable,VIcon,VSpacer,VTextField,VToolbar,VToolbarTitle,VTooltip})
